import {
  Stack,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";

import { ReactComponent as IconCalendar } from "../../../images/iconCalendar.svg";
import { ReactComponent as IconRemedy } from "../../../images/iconRemedy.svg";
import { ReactComponent as IconDocument } from "../../../images/iconFiles.svg";
import { ReactComponent as IconVaccination } from "../../../images/iconVaccination.svg";

import "../../PrimeiraConsulta/modulos/styles.css";
import { FieldSelect, FieldDatePicker } from "../../../components/Fields";
import { formatDateISO8601 } from "../../../utils/formatarData";
import "./styles.css";
import TableGridData from "../../../components/TableGridData";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "16px 0px" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function HistoricoPaciente({
  especialidade,
  setEspecialidade,
  especialidadeList,
  dataInicio,
  setDataInicio,
  dataFim,
  setDataFim,
  modalidade,
  setModalidade,
  profissional,
  setProfissional,
  profissionalList,
  unidadeDeSaude,
  setUnidadeDeSaude,
  unidadeDeSaudeList,
  value,
  handleChange,
  historicoConsultas,
  colunasConsultas,
  historicoExames,
  colunasExames,
  handleOpenDetalhesExames,
  historicoMedicamentos,
  colunasMedicamentos,
}) {
  return (
    <Accordion className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="AccordionSummaryContainer"
      >
        <Typography className="Accordion_title">
          <IconCalendar /> Histórico do paciente
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Stack
          className="templateGridForm"
          sx={{
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          }}
        >
          <FieldSelect
            label="Especialidade"
            value={especialidade}
            setValue={(value) => setEspecialidade(value === "" ? 0 : value)}
            items={[{ id: 0, nome: "Todos" }, ...especialidadeList].map(
              (item) => {
                return { id: item.id, label: item.nome };
              }
            )}
            placeholder="Especialidade"
          />
          <FieldDatePicker
            label="Data inicial"
            value={dataFim}
            setValue={(value) => setDataInicio(formatDateISO8601(value))}
            maxDate={dayjs(new Date())}
            labelDatePicker={"Data inicial"}
            required
          />
          <FieldDatePicker
            label="Data final"
            value={dataInicio}
            setValue={(value) => setDataFim(formatDateISO8601(value))}
            maxDate={dayjs(new Date())}
            labelDatePicker={"Data final"}
            required
          />
          <FieldSelect
            label="Modalidade"
            value={modalidade}
            setValue={(value) => setModalidade(value === "" ? 0 : value)}
            items={[
              { id: 0, nome: "Todos" },
              { id: "1", nome: "Presencial" },
              { id: "2", nome: "Remoto" },
              { id: "3", nome: "Híbrido" },
            ].map((item) => {
              return { id: item.id, label: item.nome };
            })}
            placeholder="Modalidade"
          />
          <FieldSelect
            label="Profissional"
            value={profissional}
            setValue={(value) => setProfissional(value === "" ? 0 : value)}
            items={[{ idUsuario: 0, nome: "Todos" }, ...profissionalList].map(
              (item) => {
                return { id: item.idUsuario, label: item.nome };
              }
            )}
            placeholder="Profissional"
          />
          <FieldSelect
            label="Unidade de saúde"
            value={unidadeDeSaude}
            setValue={(value) => setUnidadeDeSaude(value === "" ? 0 : value)}
            items={[{ id: 0, nome: "Todos" }, ...unidadeDeSaudeList].map(
              (item) => {
                return { id: item.id, label: item.nome };
              }
            )}
            placeholder="Unidade de saúde"
          />
        </Stack>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              TabIndicatorProps={{
                style: {
                  background: "#1E729F",
                },
              }}
              sx={{
                fontFamily: "Nunito",
                fontWeight: 400,
              }}
              value={value}
              onChange={handleChange}
              aria-label="center"
            >
              <Tab
                className="tabTitle"
                label="Consultas"
                icon={<IconDocument />}
                iconPosition="start"
                {...a11yProps(0)}
              />
              <Tab
                className="tabTitle"
                label="Exames"
                icon={<IconVaccination />}
                iconPosition="start"
                {...a11yProps(1)}
              />
              <Tab
                className="tabTitle"
                label="Medicamentos"
                icon={<IconRemedy />}
                iconPosition="start"
                {...a11yProps(2)}
              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <TableGridData
              rows={historicoConsultas ?? []}
              columns={colunasConsultas}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <TableGridData
              rows={historicoExames ?? []}
              columns={colunasExames}
              onCellClick={handleOpenDetalhesExames}
            />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <TableGridData
              rows={historicoMedicamentos ?? []}
              columns={colunasMedicamentos}
            />
          </CustomTabPanel>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
